import React, { ErrorInfo } from 'react'

type State = {
  error: Error | undefined
  errorInfo: ErrorInfo | undefined
  hasError: boolean
}

class ErrorBoundary extends React.Component {
  state: State = {
    error: undefined,
    errorInfo: undefined,
    hasError: false,
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error({ error, errorInfo })

    this.setState({ ...this.state, errorInfo, error })
  }

  render() {
    const { hasError, errorInfo, error } = this.state
    if (hasError) {
      return (
        <div>
          <div>
            <p>
              An error has occurred in this component.{' '}
              <span
                style={{ cursor: 'pointer', color: '#0077FF' }}
                onClick={() => {
                  window.location.reload()
                }}
              >
                Reload this page
              </span>{' '}
            </p>
          </div>

          <div>
            <details>
              <summary>Click for error details</summary>
              <div>{error && error.message}</div>
              <div>{errorInfo && errorInfo.componentStack.toString()}</div>
            </details>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
